import { useMemo, useState } from 'react';
import styled from 'styled-components';

import { Flex, Space, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import { useModalContext } from '@/components/Modal/Modal';
import Heading from '@/components/Typography/Heading';
import service from '@/services';
import { modalStyle } from '@/styles/style';

import AnalysisTriggerOptions from '../../components/AnalysisTriggerOptions';
import type { ImportRuleT } from '../types/types';
import { ChanneltalkImportTemplate } from './constants';

type Props = {
  alias: string;
  importRule?: ImportRuleT;
};

const ChanneltalkTriggerSettingModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const [importOptionValue, setImportOptionValue] = useState(
    props.importRule || { status: 1, bound: 1, tag: 1, tag_names: [] },
  );
  const [loading, setLoading] = useState(false);
  const onSaveClick = async () => {
    setLoading(true);
    try {
      await service.channeltalk.updateChanneltalkImportOption(
        props.alias,
        importOptionValue,
      );
      closeModal();
    } catch (e) {
      //  error handling
    } finally {
      setLoading(false);
    }
  };

  const disabled = useMemo(() => {
    if (
      importOptionValue.tag === ChanneltalkImportTemplate.tag.import[0] ||
      importOptionValue.tag === ChanneltalkImportTemplate.tag.doNotImport[0]
    ) {
      if (
        !importOptionValue.tag_names ||
        importOptionValue.tag_names.length < 1
      ) {
        return true;
      }
    }
    return false;
  }, [importOptionValue]);

  return (
    <Style>
      <Heading type="h2">AI analysis trigger options</Heading>
      <Space h={32} />
      <AnalysisTriggerOptions
        importRule={importOptionValue}
        setImportRule={setImportOptionValue}
        template={ChanneltalkImportTemplate}
      />
      <Space h="40px" />
      <Flex j="flex-end">
        <Button
          sizeType="m"
          isLoading={loading}
          onClick={onSaveClick}
          disabled={disabled}
        >
          Save change
        </Button>
      </Flex>
    </Style>
  );
};

const Style = styled(VFlex)`
  width: 600px;
  padding: 32px;
  ${modalStyle};
`;

export default ChanneltalkTriggerSettingModal;
